<template>
	<div class="main bg-white h-full flex flex-col flex-row">
		<div class="flex flex-col flex-grow">
			<AppsEmployeeSiteHeader @openMenu="openMenu" />
			<div class="font-bold" v-if="getAppsEmployeeDamageCase?.vehicle != null">
				<div v-if="getLicensePlate != null" class="text-center justify-center flex flex-grow mt-4" style="text-align: center">
					<LicensePlateInputShowOnly ref="LicensePlateInput" v-model="getLicensePlate" class="min-w-80 h-20" />
				</div>
				<span v-else>VIN: {{ getVin }} </span>
			</div>
			<div class="flex flex-grow w-full">
				<router-view @scrollUp="$emit('scrollUp')" class="ml-10 mr-10 mb-10"></router-view>
			</div>
		</div>
	</div>
</template>

<script>
import AppsEmployeeSiteHeader from '@/apps/employee/components/SiteHeader';
import AppsEmployee from '@/mixins/AppsEmployee';
import LicensePlateInputShowOnly from '@/components/forms/inputs/LicensePlateInputShowOnly.vue';

export default {
	name: 'AppsEmployeeApp',
	components: { LicensePlateInputShowOnly, AppsEmployeeSiteHeader },
	mixins: [AppsEmployee],
	computed: {
		getLicensePlate() {
			return {
				text: this.getAppsEmployeeDamageCase?.vehicle?.license_plate,
				isSpecial: this.getAppsEmployeeDamageCase?.vehicle?.is_license_plate_special,
			};
		},
		getVin() {
			return this.getAppsEmployeeDamageCase?.vehicle.vin;
		},
	},
	methods: {
		openMenu() {
			if (this.$route.name === 'AppsEmployeeRepairPlanTasksDetail') {
				this.$router.push({ name: 'AppsEmployeeRepairPlanTasks' });
			} else {
				this.$router.push({ name: 'AppsEmployeeMain' });
			}
		},
	},
};
</script>

<style>
@media only screen and (max-width: 920px) {
	html {
		@apply overflow-hidden;
	}

	#app {
		@apply overflow-auto max-h-screen bg-white;
	}
}
</style>
